export const BETA_FEATURE_CHARGEBEE_TRANSACTIONAL = 'chargebee_transactional_invoicing_enabled'
